import { ScopedProvider } from '@lemon8/webapp-shared';
import { FC } from 'react';
import {
  $LabelVisible,
  $LabelSwitcherVisible,
  $CurrentGallerySlide,
  $CurrentGalleryArticle,
  $CurrentMainSlide,
  $EnableIndexForRecommend,
  $CurrentEndRecommendSlide,
  $EndRecommendSwiper,
  $GallerySwiper,
  $MainSwiper,
  $CurrentArticleRelatedPost,
  useMountCurrentSlideWithSwiper,
  $NestedSwiperSlideInfo,
  $SlideToNestedIndex,
  EArticleGalleryLayoutStrategy,
  $LayoutStrategy,
  $RootPaddingBottom,
  $LoadArticleRelatedPosts,
  $CurrentArticleLoadableRelatedPost,
} from './atoms';
import {
  DotIndicatorSection,
  EndRecommendSection,
  GalleryIndex,
  GallerySection,
  LabelVisibleSwitcher,
  MainSwiper,
  SwiperAction,
  WarningLabelSection,
} from './components';
import { IGalleryArticleDetail } from 'shared/models';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { IArticleRelatedPost } from 'shared/atoms';

const ArticleGalleryImpl: FC = () => {
  useMountCurrentSlideWithSwiper($MainSwiper, $CurrentMainSlide);
  useMountCurrentSlideWithSwiper($GallerySwiper, $CurrentGallerySlide);

  return (
    <>
      <SwiperAction>
        <MainSwiper>
          <GallerySection>
            <LabelVisibleSwitcher />
            <GalleryIndex />
            <WarningLabelSection />
          </GallerySection>
          <EndRecommendSection />
        </MainSwiper>
      </SwiperAction>
      <DotIndicatorSection />
    </>
  );
};

interface IArticleGalleryProps {
  /** data */
  article: IGalleryArticleDetail;
  articleRelatedPosts: PromiseOrValue<IArticleRelatedPost>;
  loadArticleRelated?: () => void;

  /** config */
  enableIndexForRecommend: boolean;
  layoutStrategy?: EArticleGalleryLayoutStrategy;
}

export const ArticleGallery: FC<IArticleGalleryProps> = (props) => {
  const {
    article,
    enableIndexForRecommend,
    articleRelatedPosts,
    layoutStrategy = EArticleGalleryLayoutStrategy.SQUARE,
    loadArticleRelated,
  } = props;

  return (
    <ScopedProvider
      atoms={[
        /** swiper */
        $MainSwiper,
        $GallerySwiper,
        $EndRecommendSwiper,

        /** swiper slide */
        $CurrentMainSlide,
        $CurrentGallerySlide,
        $CurrentEndRecommendSlide,
        $CurrentArticleLoadableRelatedPost,

        /** nested swiper slides */
        $NestedSwiperSlideInfo,
        $SlideToNestedIndex,

        // gallery label
        $LabelVisible,
        $LabelSwitcherVisible,

        /** additional config */
        $RootPaddingBottom,
      ]}
      atomsWithHydration={[
        [$CurrentGalleryArticle, article],
        [$CurrentArticleRelatedPost, articleRelatedPosts],
        [$EnableIndexForRecommend, enableIndexForRecommend],
        [$LayoutStrategy, layoutStrategy],
        [$LoadArticleRelatedPosts, { loader: loadArticleRelated }],
      ]}
    >
      <ArticleGalleryImpl />
    </ScopedProvider>
  );
};
